import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface BackButtonProps {
  handleBack: () => void;
  label?: string;
  className?: string;
}

export const BackButton = ({
  handleBack,
  label,
  className,
}: BackButtonProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.COMMON);
  return (
    <Button
      type="button"
      variant="terciary"
      className={cn('w-fit', className)}
      size="lg"
      icon="back"
      onClick={handleBack}
    >
      <ChevronLeft className="size-5" />
      {label ?? t('Common.back')}
    </Button>
  );
};
